import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {styled} from "@mui/material/styles";

import Badge from "components/Badge";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import ScoreLevelBars from "../../ScoreLevelBars";

import {getScoreLevel, getScoreTheme} from "../../../../../../../utils/ScoreColorCalculator";

import {greyishBlue700} from "assets/jss/main";

LevelScoreBadge.propTypes = {
    score: PropTypes.number,
    tooltipId: PropTypes.string
};

const BadgeLineHeightFix = styled('div')({
    display: 'contents',
    '& > div > span': {
        display: 'flex',
        lineHeight: 'inherit',
        alignItems: 'center'
    }
});

function LevelScoreBadge({score, tooltipId, onClick = () => {}}) {
    if (score == null) {
        return (
            <BadgeLineHeightFix>
                <Badge
                    color={'draft'}
                    size={'default'}
                    isBold={false}
                    labelColor={greyishBlue700}
                    labelSize={14}
                    border
                    onClick={onClick}
                >
                    NA
                    <span style={{display: 'flex', marginLeft: '4px'}}>
                        <InfoTooltipIcon titleId={tooltipId} color={greyishBlue700}/>
                    </span>
                </Badge>
            </BadgeLineHeightFix>
        );
    }

    const scoreTheme = getScoreTheme(score);

    if (scoreTheme === null) {
        return null;
    }

    const scoreLevel = getScoreLevel(score)

    let messageId;

    if (scoreLevel === 0) {
        messageId = 'retailer.product.scoring.level.low';
    } else if (scoreLevel === 1) {
        messageId = 'retailer.product.scoring.level.medium';
    } else {
        messageId = 'retailer.product.scoring.level.high';
    }

    return (
        <BadgeLineHeightFix>
            <Badge
                color={scoreTheme.theme}
                size={'default'}
                indicatorIcon={<ScoreLevelBars score={score}/>}
                isBold={false}
                labelColor={scoreTheme.color}
                labelSize={14}
                border
                onClick={onClick}
            >
                <FormattedMessage id={messageId} />
                <span style={{display: 'flex', marginLeft: '4px'}}>
                    <InfoTooltipIcon titleId={tooltipId} color={scoreTheme.color}/>
                </span>
            </Badge>
        </BadgeLineHeightFix>
    );
}

export default LevelScoreBadge;
